import { User } from 'types';

import handleApiError from './utils/handle-api-err';
import provider from './provider';
import {
  API_Services,
  initCompanyServices,
  initGeolocatorServices,
  ResponseEnvelop
} from '.';

const services = (
  api_host: string,
  geolocator_baseUrl: string,
  geid?: string
): API_Services => {
  const instance = provider(api_host);
  const options = {
    host: api_host,
    provider: instance.request
  };

  const geolocatorApiHost = geolocator_baseUrl.replace('https://', '');
  const geolocatorInstance = provider(geolocatorApiHost, {
    corporate_admin_api_host: api_host,
    geid: geid || ''
  });
  const geolocatorOptions = {
    host: geolocatorApiHost,
    provider: geolocatorInstance.request,
    version: 2
  };

  return {
    company: initCompanyServices(options),
    user: {
      async get() {
        try {
          const response = await instance.get<ResponseEnvelop<User>>(
            '/api/v5/corporate-api/company-portal/auth/me'
          );
          return response.data.data;
        } catch (err) {
          throw handleApiError(err);
        }
      }
    },
    geolocator: initGeolocatorServices(geolocatorOptions)
  };
};

export default services;
